const get = (item: string) => {
  return localStorage.getItem(item) ? JSON.parse(localStorage.getItem(item)!) : undefined
}

const set = (item: string, value: any) => {
  localStorage.setItem(item, JSON.stringify(value))
}

export { get, set }
